<template>
  <basic-container>
    <el-form ref="searchForm" :model="query" label-width="100px" margin-top="0" :rules="rules">
      <el-row>
      <el-col :span="4">
        <el-form-item label="速记码" prop="shortCode">
          <el-input
            v-model="query.shortCode"
            @input="propertyFilter()"
            placeholder="速记码"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="小区名称" prop="propertyId">

                <avue-input-tree 
                    node-key="id"
                    :props="defaultProps"
                    default-expand-all 
                    v-model="query.propertyId" 
                    placeholder="请选择小区" 
                    type="select" 
                    @change="communityIdChange"
                    :dic="allPropertyListCopy"
                >
                </avue-input-tree>
          <!-- <el-select v-model="query.propertyId" placeholder="请选择小区" style="width: 100%;">
            <el-option
              v-for="item in allPropertyListCopy"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="缴费人" prop="householdName">
          <el-input v-model="query.householdName" placeholder="缴费人"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="7">
        <el-form-item label="收费日期 从" prop="dateRange">
          <el-date-picker
              style="width:42%;"
              v-model="query.dateFrom"
              type="date"
              value-format="yyyy-MM-dd 00:00:00.000"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.dateTo"
              type="date"
              value-format="yyyy-MM-dd 23:59:59.999"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="票据号" prop="invoiceNo">
          <el-input v-model="query.invoiceNo" placeholder="票据号"></el-input>
        </el-form-item>
      </el-col>

      </el-row>


      <el-col :span="4">
        <el-form-item label="支付方式" prop="payType">
          <el-select v-model="query.payType" placeholder="全部" style="width: 100%;">
            <el-option
              v-for="item in allPayTypeList"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="应缴金额" prop="shouldAmountSum">
          <el-input :value="shouldAmountSum" :disabled="true"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="实收金额" prop="payAmountSum">
          <el-input :value="payAmountSum" :disabled="true"> </el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
            @click.prevent="submitSearchForm"
            >搜索</el-button
          >
          <el-button type="white" @click="searchReset" icon="el-icon-delete">清空</el-button>
        </el-form-item>
      </el-col>

    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <!--        <el-button type="primary" size="small" icon="el-icon-plus" @click="exportExcel()"-->
        <!--          >导 出-->
        <!--        </el-button>-->
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  payBillDiscountsAmount,
  payBillDiscountsExcel,
  payBillDiscountsPage,
} from '@/api/v4ward/paybilllist/feepaybilllist';
import { mapGetters } from 'vuex';
import { getOptionNode } from '../../../api/v4ward/property/baseproperty';
import { getDictionary } from '../../../api/common';

export default {
  data() {
    return {
        defaultProps:{
            children: 'children',
            label: 'title',
        value: 'id',
        },
      //如果已经根据速记码查询过了小区信息则为true
      payAmountSum: '',
      shouldAmountSum: '',
      arrearageAmountSum: '',
      dateRange: [],
      allPayTypeList: [],
      allPropertyList: [],
      allPropertyListCopy: [],
      allSortTypeList: [],
      treeProps: {
        //标题
        label: 'title',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
      },
      propertyName: '',
      form: {},
      query: {
        shortCode: '',
        propertyId: '',
        payType: '',
        billStartDate: '',
        payFlag: '',
        dateFrom:'',
        dateTo:'',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: false,
        excelBtn: false,
        selection: false,
        menu: false,
        menuPosition: 'center',
        align: 'center',
        column: [
          {
            label: '地址',
            prop: 'roomName',
          },
          {
            label: '收费周期',
            prop: 'billcycleNo',
          },
          {
            label: '缴费人',
            prop: 'householdName',
          },
          {
            label: '收费时间',
            prop: 'payTime',
            type: 'date',
            format: 'yyyy-MM-dd HH:mm:ss',
            valueFormat: 'yyyy-MM-dd HH:mm:ss',
          },
          {
            label: '应收金额',
            prop: 'shouldAmount',
          },
          {
            label: '滞纳金',
            prop: 'delayAmount',
          },
          {
            label: '账户抵扣金额',
          prop: 'accountpayAmount',
          },
          {
            label: '优惠券抵扣金额',
            prop: 'couponAmount',
          },
          {
            label: '减免金额',
            prop: 'derateAmount',
          },

          {
            label: '收费金额',
            prop: 'payAmount',
          },

          {
            label: '支付方式',
            prop: 'payType',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
            dataType: 'number',
          },
          {
            label: '收款人',
            prop: 'cashierName',
          },
          {
            label: '票据号',
            prop: 'invoiceNo',
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.basebankchangeinfo_add, false),
        viewBtn: this.vaildData(this.permission.basebankchangeinfo_view, false),
        delBtn: this.vaildData(this.permission.basebankchangeinfo_delete, false),
        editBtn: this.vaildData(this.permission.basebankchangeinfo_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.initDefaultDateRange();
    this.initPropertyList();
    this.initPayTypeList();
  },
  methods: {
    //监听速记码变化过滤房产信息
    propertyFilter() {
      let val = this.query.shortCode;
      if (val) {
        //速记码存在,改变小区过滤状态，清除小区下拉框选中状态
        this.allPropertyListCopy = this.allPropertyList.filter(function (item) {
          return item.shortCode.indexOf(val) > -1;
        });
        this.propertyIsQuery = true;
      } else {
        //val为空时，还原数组,将过滤状态还原，清除小区下拉框选中状态
        this.allPropertyListCopy = this.allPropertyList;
        this.propertyIsQuery = false;
        this.query.propertyId = '';
      }
      if (this.allPropertyListCopy.length > 0){
        // this.query.propertyId = this.allPropertyListCopy[0].id;
        this.query = Object.assign({},this.query,{propertyId:this.allPropertyListCopy[0].id})
      }
      else this.query.propertyId = '';
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.tool.clearObject(this.query);
      this.initDefaultDateRange()
      this.propertyFilter();
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    submitSearchForm() {
      //this.initPropertyList();
      this.searchChange(this.query);
    },
    onLoad(page) {
     
      if (this.propertyIsQuery && !this.query.propertyId) {
        if (this.allPropertyListCopy.length > 0) {
          this.query.propertyId = this.allPropertyListCopy[0].id;
        } else {
          this.$message.error('未查询到任何小区，请重新输入速记码!');
          return;
        }
      }
      page = page || this.page;
      this.loading = true;
      if (!this.query.propertyId) {
        getOptionNode({}).then((data) => {
          this.query.propertyId = data.data[0].id;
          payBillDiscountsPage(
            Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
          ).then(({ data }) => {
            this.page.total = data.ipage.total;
            this.data = data.ipage.records;
            this.loading = false;
            this.selectionClear();
          });
          this.getAmount();
        });
        return;
      }
      payBillDiscountsPage(
        Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
      ).then(({ data }) => {
        this.page.total = data.ipage.total;
        this.data = data.ipage.records;
        this.loading = false;
        this.selectionClear();
      });
      this.getAmount();
    },
    clearProperty() {
      this.propertyName = '';
      this.query.roomId = '';
    },
    getAmount: function () {
      payBillDiscountsAmount(Object.assign(this.query)).then(({ data }) => {
        this.shouldAmountSum = data.shouldAmountSum;
        this.payAmountSum = data.payAmountSum;
        this.arrearageAmountSum = data.arrearageAmountSum;
      });
    },
    initPropertyList() {
      getOptionNode({}).then((data) => {
        if (this.propertyIsQuery) {
          this.allPropertyList = data.data;
        } else {
          this.allPropertyList = data.data;
          this.allPropertyListCopy = data.data;
        }
      });
    },

    initDefaultDateRange() {
      this.dateRange = [this.getCurrentMonthFirst(), this.getCurrentMonthLast()];
      this.query.dateFrom=this.getCurrentMonthFirst() + " 00:00:00.000"
      this.query.dateTo=this.getCurrentMonthLast() +" 23:59:59.999"
    },
    getCurrentMonthFirst: function () {
      var date = new Date();
      date.setDate(1);
      var month = parseInt(date.getMonth() + 1);
      var day = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    getCurrentMonthLast: function () {
      var date = new Date();
      var currentMonth = date.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      var lastTime = new Date(nextMonthFirstDay - oneDay);
      var month = parseInt(lastTime.getMonth() + 1);
      var day = lastTime.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    initPayTypeList: function () {
      getDictionary('pay_type').then((data) => {
        this.allPayTypeList = data.data;
      });
    },
    //导出
    exportExcel() {
      this.$confirm('确定导出所有数据?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        payBillDiscountsExcel(Object.assign({}, this.query)).then(({ data }) => {
          // 需要导出的数据，可以动态获取
          import('@/vendor/Export2Excel.js').then((excel) => {
            // 导入js模块
            const tHeader = [
              '地址',
              '收费周期',
              '缴费人',
              '收费时间',
              '应收金额',
              '滞纳金',
              '抵扣金额',
              '优惠金额',
              '收费金额',
              '支付方式',
              '收款人',
              '票据号',
            ]; // 导出excel 的标题
            const filterVal = [
              'roomName',
              'billcycleNo',
              'householdName',
              'payTime',
              'shouldAmount',
              'delayAmount',
              'accountpayAmount',
              'derateAmount',
              'payAmount',
              'payType',
              'cashierName',
              'invoiceNo',
            ]; // 每个标题对应的字段

            const list = (data || []).map((item, key) => {
              // 通过 map 方法遍历，组装数据成上面的格式
              return {
                roomName: item.roomName,
                billcycleNo: item.billcycleNo,
                householdName: item.householdName,
                payTime: item.payTime ? this.dayjs(item.payTime).format('YYYY-MM-DD HH:mm:ss') : '',
                shouldAmount: item.shouldAmount,
                delayAmount: item.delayAmount,
                accountpayAmount: item.accountpayAmount,
                derateAmount: item.derateAmount,
                payAmount: item.payAmount,
                payType: this.payTypeToPayTypeName(item.payType),
                cashierName: item.cashierName,
                invoiceNo: item.invoiceNo,
              };
            });

            if (list.length > 0) {
              const data = this.formatJson(filterVal, list); // 生成json数据
              excel.export_json_to_excel({
                // 调用excel方法生成表格
                header: tHeader,
                data,
                filename: '物业费优惠查询' + this.dayjs(new Date()).format('YYYYMMDDHHmmss'),
              });
            } else {
              this.$message.error('暂无有效数据');
            }
          });
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    payTypeToPayTypeName(payType) {
      var payTypeName = '';
      this.allPayTypeList.forEach(function (value, index, array) {
        if (value.dictKey == payType) {
          payTypeName = value.dictValue;
          return;
        }
      });
      return payTypeName;
    },
  },
};
</script>

<style scoped>
.el-dialog__body {
  padding: 0 30px;
}
.el-dialog__body .el-card__body {
  padding: 0;
}
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  padding: 5px;
  overflow: hidden;
  overflow-y: auto;
}
.el-select-dropdown__item.selected {
  font-weight: normal;
}
/deep/.el-input.is-disabled .el-input__inner {
  color: red;
}
.el-date-editor.el-input {
  width: 100%;
}
</style>
